if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      // Check if addons exist and add these to the cart if they do
      let productAddonsSection = document.querySelector('.product-addons');
      let productAddons = document.querySelectorAll('.product-addon');
      
      if(productAddonsSection) {
        console.log('addons');
        let cartAddons = {
          items: []
        };

        // add the main product to the cart json
        let mainItemCartLineItem = {
          id: this.form.querySelector('[name="id"]').value,
          quantity: document.querySelector('.main-product-qty').value,
        }
        cartAddons.items.push(mainItemCartLineItem);

        //map each selected addon to the cart json
        productAddons.forEach(productAddon => {
            let selectionStatus = productAddon.querySelector('.product-addon__checkbox');
          	let selectionQty = productAddon.querySelector('.quantity__input');
            let cartLineItem = {};
            if(selectionStatus.checked && selectionQty.value >= 1) {
                let productID;
              	let productVariant = productAddon.querySelector('.variant-select');
                if(productVariant) {
                  productID = productVariant.value;
                } else {
                  productID = productAddon.dataset.productId;
                }
                cartLineItem.id = productID;
                cartLineItem.quantity = productAddon.querySelector('.quantity__input').value;
                cartAddons.items.push(cartLineItem);
            }
        });

        
      
        if(cartAddons.items.length > 0) {
          let cartItems = cartAddons.items;
          const body = JSON.stringify({
            items: cartItems,
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          });
          console.log(body);
          fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
            .then((response) => response.json())
            .then((parsedState) => {
              console.log(parsedState);
              this.cartNotification.renderContentsAddons(parsedState);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('disabled');
            });
        }
      } else {
        console.log('regular');
        //Add main Product to the cart
        const body = JSON.stringify({
          ...JSON.parse(serializeForm(this.form)),
          sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        });
        console.log(body);
        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((parsedState) => {
            console.log(parsedState);
            this.cartNotification.renderContents(parsedState);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
          });
      }
    }
  });
}




